// extracted by mini-css-extract-plugin
export default {"wrapper":"blog-card_wrapper__zL8JJ","boxThumbnail":"blog-card_boxThumbnail__5bcNN","boxTitle":"blog-card_boxTitle__Dg6u2","content":"blog-card_content__CjJS3"};